// extracted by mini-css-extract-plugin
export default {"wrapper":"loaderMessage_wrapper__4IjpZ","message":"loaderMessage_message__V4ntA"};